var map = {
	"./arrow-down.svg": 76459,
	"./arrow-up.svg": 53060,
	"./arrow.svg": 26098,
	"./cross.svg": 51593,
	"./export.svg": 14369,
	"./sync.svg": 36614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51241;